module.exports = __webpack_public_path__ + "img/created_invoices.17ccf08a.svg";